import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

const Tooltip = ({ children, content, position = 'top', maxWidth = '24rem' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  
  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const scrollY = window.scrollY || window.pageYOffset;
      const scrollX = window.scrollX || window.pageXOffset;
      
      let top = 0;
      let left = 0;
      
      switch (position) {
        case 'top':
          top = rect.top + scrollY - 8; // 8px for spacing
          left = rect.left + scrollX + (rect.width / 2);
          break;
        case 'bottom':
          top = rect.bottom + scrollY + 8;
          left = rect.left + scrollX + (rect.width / 2);
          break;
        case 'left':
          top = rect.top + scrollY + (rect.height / 2);
          left = rect.left + scrollX - 8;
          break;
        case 'right':
          top = rect.top + scrollY + (rect.height / 2);
          left = rect.right + scrollX + 8;
          break;
        default:
          break;
      }
      
      setTooltipPosition({ top, left });
    }
  }, [isVisible, position]);
  
  const getTransformClasses = () => {
    switch (position) {
      case 'top':
        return 'transform -translate-x-1/2 -translate-y-full';
      case 'bottom':
        return 'transform -translate-x-1/2';
      case 'left':
        return 'transform -translate-x-full -translate-y-1/2';
      case 'right':
        return 'transform -translate-y-1/2';
      default:
        return '';
    }
  };
  
  return (
    <>
      <div
        ref={triggerRef}
        className="inline-block"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onTouchStart={() => setIsVisible(!isVisible)}
      >
        {children}
      </div>
      
      {isVisible && ReactDOM.createPortal(
        <div 
          className={`fixed z-[99999] pointer-events-none ${getTransformClasses()}`}
          style={{ 
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`
          }}
        >
          <div 
            className={`
              px-4 py-3 rounded-lg text-mono text-xs leading-relaxed
              bg-gray-900 text-white border border-gray-800
              shadow-xl backdrop-blur-sm
            `}
            style={{ 
              maxWidth: maxWidth, 
              minWidth: '200px',
              wordWrap: 'break-word',
              whiteSpace: 'normal'
            }}
          >
            {content}
            <div className={`absolute w-2 h-2 transform rotate-45 
              ${position === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2' : ''}
              ${position === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2' : ''}
              ${position === 'left' ? 'right-[-4px] top-1/2 -translate-y-1/2' : ''}
              ${position === 'right' ? 'left-[-4px] top-1/2 -translate-y-1/2' : ''}
              bg-gray-900
            `} />
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default Tooltip;